// components/MonthlyDonationsChart.tsx
import React from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const monthLabels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]

const MonthlyDonationsChart = ({ data, year }) => {
    const parsedData = data.map(val => parseFloat(val) || 0)
    const { t } = useTranslation()

    const chartData = {
        labels: monthLabels,
        datasets: [
            {
                label: `${t('dashboard.donation_income')} - ${year}`,
                data: parsedData,
                backgroundColor: '#3b82f6',
                borderRadius: 4,
            },
        ],
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `${t('dashboard.donation_income')} - ${year}`,
            },
        },
    }

    return <Bar options={options} data={chartData} />
}

export default MonthlyDonationsChart
